/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для настроек пользователя в кабинете
   */
  app.UserSettingsView = app.View.extend({
    el: '#user-settings-form',
    parserAttrs: ['is_cloudparser_enabled'],

    events: {
      'click #is_subscribed_for_newsletter': 'changeSubscribeStatus',
      'click #is_subscribed_on_order_status': 'changeSubscribeStatus',
      'click #change-password-button': 'changePassword',
      'click #is-parser-enabled': 'changeParserEnabled',
      'click #logout': 'logoutUser',
    },

    run: function () {
      this.childViews.changePasswordFormView = new app.ChangePasswordFormView({
        parent: this,
        user: this.user,
      });
      this.childViews.selectView = new app.SelectView({
        model: new app.Model(),
        el: this.$('.select'),
        activeValueSelector: '.select_active',
        field: 'selected_parser',
        inputSelector: '.select_active',
        optionsSelector: '.js-options',
        optionsTemplateName: '#select-parser-options-template'
      });
      this.listenTo(this.childViews.selectView.model, 'change:selected_parser', this.selectEnabledParser);
    },

    changeSubscribeStatus: function (e) {
      var attributes = [];

      attributes[e.target.id] = $(e.target).prop('checked');
      app.user.save(attributes);

      if (app.user.hasChanged()) {
        this.viewSubscribeStatusLabel();
      }
    },
    viewSubscribeStatusLabel: function () {
      var that = this,
        userChangedAttributes = app.user.changedAttributes(),
        i;

      for (i in userChangedAttributes) {
        if (userChangedAttributes.hasOwnProperty(i)) {
          $('[data-id="' + i + '"]').removeClass('hidden');
          setTimeout(that.hideSubscribeStatusLabel(i), 3000);
        }
      }
    },

    hideSubscribeStatusLabel: function (i) {
      $('[data-id="' + i + '"]').addClass('hidden');
    },

    changePassword: function () {
      this.trigger('formPasswordToggle');
      this.toggle();
    },
    /**
     * Изменение галочки включения, отключения парсера.
     * @param e
     */
    changeParserEnabled: function (e) {
      if ($(e.currentTarget).prop('checked')) {
        this.childViews.selectView.model.set({selected_parser: 'is_cloudparser_enabled'});
      } else {
        this.childViews.selectView.model.set({selected_parser: ''});
      }
    },
    /**
     * Обработка парсера.
     * @param model
     */
    selectEnabledParser: function (model) {
      var selected = model.get('selected_parser'),
        attributes = {};
      _.each(this.parserAttrs, function (attr) {
        attributes[attr] = attr === selected;
      });
      this.$('#is-parser-enabled').prop('checked', Boolean(selected));
      app.user.save(attributes);
    },

    /**
     * Деавторизует пользователя и отправляет событие в oko.
     */
    logoutUser: function () {
      app.helpers.OkoHelper.push({ n: 'logout', 'type_id': 1 } );
      window.location.assign('/logout/');
    },

  });
})(jQuery);

}.call(window));